/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MuDataProcessingModelsActivityIntervalExternalDevice,
    MuDataProcessingModelsActivityIntervalExternalDeviceFromJSON,
    MuDataProcessingModelsActivityIntervalExternalDeviceFromJSONTyped,
    MuDataProcessingModelsActivityIntervalExternalDeviceToJSON,
    MuDataProcessingModelsActivityIntervalLive,
    MuDataProcessingModelsActivityIntervalLiveFromJSON,
    MuDataProcessingModelsActivityIntervalLiveFromJSONTyped,
    MuDataProcessingModelsActivityIntervalLiveToJSON,
    MuDataProcessingModelsDriverInfoDriver,
    MuDataProcessingModelsDriverInfoDriverFromJSON,
    MuDataProcessingModelsDriverInfoDriverFromJSONTyped,
    MuDataProcessingModelsDriverInfoDriverToJSON,
    MuDataProcessingModelsEdit,
    MuDataProcessingModelsEditFromJSON,
    MuDataProcessingModelsEditFromJSONTyped,
    MuDataProcessingModelsEditToJSON,
} from './';

/**
 * 
 * @export
 * @interface MuDataProcessingModelsActivityInterval
 */
export interface MuDataProcessingModelsActivityInterval {
    /**
     * 
     * @type {MuDataProcessingModelsEdit}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    edit?: MuDataProcessingModelsEdit;
    /**
     * 
     * @type {Array<MuDataProcessingModelsEdit>}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    edits?: Array<MuDataProcessingModelsEdit>;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    monitoredObjectId: string;
    /**
     * 
     * @type {number}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    clientId?: number;
    /**
     * 
     * @type {Date}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    stop?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    lastUpdate?: Date;
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    activityIntervalId?: string;
    /**
     * 
     * @type {Array<MuDataProcessingModelsActivityIntervalExternalDevice>}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    externalDevices?: Array<MuDataProcessingModelsActivityIntervalExternalDevice>;
    /**
     * 
     * @type {Date}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    externalDevicesLastTs?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    _private?: boolean;
    /**
     * 
     * @type {MuDataProcessingModelsDriverInfoDriver}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    driver?: MuDataProcessingModelsDriverInfoDriver;
    /**
     * 
     * @type {Array<MuDataProcessingModelsDriverInfoDriver>}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    passengers?: Array<MuDataProcessingModelsDriverInfoDriver>;
    /**
     * 
     * @type {MuDataProcessingModelsDriverInfoDriver}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    defaultDriver?: MuDataProcessingModelsDriverInfoDriver;
    /**
     * 
     * @type {MuDataProcessingModelsActivityIntervalLive}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    liveData?: MuDataProcessingModelsActivityIntervalLive;
    /**
     * 
     * @type {Array}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    positionStart?: [];
    /**
     * 
     * @type {Array}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    positionStop?: [];
    /**
     * 
     * @type {number}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    averageSpeed?: number;
    /**
     * 
     * @type {number}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    maxSpeed?: number;
    /**
     * 
     * @type {number}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    lastCarBatteryVolts?: number;
    /**
     * 
     * @type {Date}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    lastCarBatteryTimestamp?: Date;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof MuDataProcessingModelsActivityInterval
     */
    lastFuelLevelByTank?: { [key: string]: object; };
}

export function MuDataProcessingModelsActivityIntervalFromJSON(json: any): MuDataProcessingModelsActivityInterval {
    return MuDataProcessingModelsActivityIntervalFromJSONTyped(json, false);
}

export function MuDataProcessingModelsActivityIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingModelsActivityInterval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'edit': !exists(json, 'edit') ? undefined : MuDataProcessingModelsEditFromJSON(json['edit']),
        'edits': !exists(json, 'edits') ? undefined : ((json['edits'] as Array<any>).map(MuDataProcessingModelsEditFromJSON)),
        'monitoredObjectId': json['monitored_object_id'],
        'clientId': !exists(json, 'client_id') ? undefined : json['client_id'],
        'start': (new Date(json['start'])),
        'stop': !exists(json, 'stop') ? undefined : (new Date(json['stop'])),
        'lastUpdate': !exists(json, 'last_update') ? undefined : (new Date(json['last_update'])),
        'activityIntervalId': !exists(json, 'activity_interval_id') ? undefined : json['activity_interval_id'],
        'externalDevices': !exists(json, 'external_devices') ? undefined : ((json['external_devices'] as Array<any>).map(MuDataProcessingModelsActivityIntervalExternalDeviceFromJSON)),
        'externalDevicesLastTs': !exists(json, 'external_devices_last_ts') ? undefined : (new Date(json['external_devices_last_ts'])),
        '_private': !exists(json, 'private') ? undefined : json['private'],
        'driver': !exists(json, 'driver') ? undefined : MuDataProcessingModelsDriverInfoDriverFromJSON(json['driver']),
        'passengers': !exists(json, 'passengers') ? undefined : ((json['passengers'] as Array<any>).map(MuDataProcessingModelsDriverInfoDriverFromJSON)),
        'defaultDriver': !exists(json, 'default_driver') ? undefined : MuDataProcessingModelsDriverInfoDriverFromJSON(json['default_driver']),
        'liveData': !exists(json, 'live_data') ? undefined : MuDataProcessingModelsActivityIntervalLiveFromJSON(json['live_data']),
        'positionStart': !exists(json, 'position_start') ? undefined : json['position_start'],
        'positionStop': !exists(json, 'position_stop') ? undefined : json['position_stop'],
        'averageSpeed': !exists(json, 'average_speed') ? undefined : json['average_speed'],
        'maxSpeed': !exists(json, 'max_speed') ? undefined : json['max_speed'],
        'lastCarBatteryVolts': !exists(json, 'last_car_battery_volts') ? undefined : json['last_car_battery_volts'],
        'lastCarBatteryTimestamp': !exists(json, 'last_car_battery_timestamp') ? undefined : (new Date(json['last_car_battery_timestamp'])),
        'lastFuelLevelByTank': !exists(json, 'last_fuel_level_by_tank') ? undefined : json['last_fuel_level_by_tank'],
    };
}

export function MuDataProcessingModelsActivityIntervalToJSON(value?: MuDataProcessingModelsActivityInterval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'edit': MuDataProcessingModelsEditToJSON(value.edit),
        'edits': value.edits === undefined ? undefined : ((value.edits as Array<any>).map(MuDataProcessingModelsEditToJSON)),
        'monitored_object_id': value.monitoredObjectId,
        'client_id': value.clientId,
        'start': (value.start.toISOString()),
        'stop': value.stop === undefined ? undefined : (value.stop.toISOString()),
        'last_update': value.lastUpdate === undefined ? undefined : (value.lastUpdate.toISOString()),
        'activity_interval_id': value.activityIntervalId,
        'external_devices': value.externalDevices === undefined ? undefined : ((value.externalDevices as Array<any>).map(MuDataProcessingModelsActivityIntervalExternalDeviceToJSON)),
        'external_devices_last_ts': value.externalDevicesLastTs === undefined ? undefined : (value.externalDevicesLastTs.toISOString()),
        'private': value._private,
        'driver': MuDataProcessingModelsDriverInfoDriverToJSON(value.driver),
        'passengers': value.passengers === undefined ? undefined : ((value.passengers as Array<any>).map(MuDataProcessingModelsDriverInfoDriverToJSON)),
        'default_driver': MuDataProcessingModelsDriverInfoDriverToJSON(value.defaultDriver),
        'live_data': MuDataProcessingModelsActivityIntervalLiveToJSON(value.liveData),
        'position_start': value.positionStart,
        'position_stop': value.positionStop,
        'average_speed': value.averageSpeed,
        'max_speed': value.maxSpeed,
        'last_car_battery_volts': value.lastCarBatteryVolts,
        'last_car_battery_timestamp': value.lastCarBatteryTimestamp === undefined ? undefined : (value.lastCarBatteryTimestamp.toISOString()),
        'last_fuel_level_by_tank': value.lastFuelLevelByTank,
    };
}


